import React from 'react';

// SECURITY: Never expose your OpenAI API key in frontend code. All AI requests should go through a backend proxy.

export default function ChatWidget() {
  const [chatOpen, setChatOpen] = React.useState(false);
  const [chatMessages, setChatMessages] = React.useState([
    { sender: 'bot', text: 'Hi! I am your AI assistant. How can I help you today?' }
  ]);
  const [chatInput, setChatInput] = React.useState("");
  const [chatLoading, setChatLoading] = React.useState(false);
  const chatMessagesRef = React.useRef(chatMessages);
  React.useEffect(() => { chatMessagesRef.current = chatMessages; }, [chatMessages]);

  // Send message to AI backend (always via backend proxy for security)
  const sendChatMessage = async (msg) => {
    setChatLoading(true);
    setChatMessages(prev => {
      const updated = [...prev, { sender: 'user', text: msg }];
      chatMessagesRef.current = updated;
      return updated;
    });
    setChatInput("");
    try {
      const res = await fetch('/api/ai-chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: [
            { role: 'system', content: 'You are a helpful support assistant for a DEX app. Always respond with concise, short answers. Keep your replies under 30 words.' },
            ...chatMessagesRef.current.map(m => ({ role: m.sender === 'user' ? 'user' : 'assistant', content: m.text })),
            { role: 'user', content: msg }
          ]
        })
      });
      const data = await res.json();
      const aiText = data.choices?.[0]?.message?.content || data.reply || 'Sorry, I could not process your request.';
      setChatMessages(prev => {
        const updated = [...prev, { sender: 'bot', text: aiText }];
        chatMessagesRef.current = updated;
        return updated;
      });
    } catch (e) {
      setChatMessages(prev => {
        const updated = [...prev, { sender: 'bot', text: 'Sorry, there was an error contacting support.' }];
        chatMessagesRef.current = updated;
        return updated;
      });
    }
    setChatLoading(false);
  };

  return (
    <div className={`chat-widget${chatOpen ? ' open' : ''}`}>
      {chatOpen ? (
        <div className="chat-window">
          <div className="chat-header">
            <span>AI Support</span>
            <button className="chat-close" onClick={() => setChatOpen(false)}>&times;</button>
          </div>
          <div className="chat-messages">
            {chatMessages.map((m, i) => (
              <div key={i} className={`chat-message ${m.sender}`}>{m.text}</div>
            ))}
            {chatLoading && <div className="chat-message bot">...</div>}
          </div>
          {/* Confluence documentation link */}
          <div className="chat-doc-link-row">
            <a
              href="https://ergonenergy.atlassian.net/wiki/external/ZGY1OTQ4ZGIyOWZlNDE3ZWE3NWQ0ZDM1ZTcxZDUyODI"
              target="_blank"
              rel="noopener noreferrer"
              className="confluence-link"
            >
              📖 View Documentation
            </a>
          </div>
          <form className="chat-input-row" onSubmit={e => { e.preventDefault(); if (chatInput.trim()) sendChatMessage(chatInput); }}>
            <input
              type="text"
              value={chatInput}
              onChange={e => setChatInput(e.target.value)}
              placeholder="Type your question..."
              disabled={chatLoading}
            />
            <button type="submit" disabled={chatLoading || !chatInput.trim()}>Send</button>
          </form>
        </div>
      ) : (
        <button className="chat-open-btn" onClick={() => setChatOpen(true)}>
          💬 Chat
        </button>
      )}
    </div>
  );
}
